import { Component, OnInit, Input } from '@angular/core';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { TransportMode } from 'src/app/models/transportMode.model';
import { BoardingPlaceDensityOfPeopleFactor, BoardingPlaceDensityOfPeopleFactorValue } from 'src/app/models/BoardingPlaceDensityOfPeopleFactor.model';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { CloneService } from 'src/app/services/clone.service';
import { BoardingPlaceDensityOfPeopleFactorData } from './BoardingPlaceDensityOfPeopleFactorData.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';

@Component({
  selector: 'app-boarding-place-density-of-people-factor',
  templateUrl: './boarding-place-density-of-people-factor.component.html',
  styleUrls: ['./boarding-place-density-of-people-factor.component.scss']
})
export class BoardingPlaceDensityOfPeopleFactorComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('boardingPlaceDensityOfPeopleFactor', this._formBuilder.array([]));
    this.form.setControl('boardingPlaceDensityOfPeopleFactor', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('boardingPlaceDensityOfPeopleFactor');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as BoardingPlaceDensityOfPeopleFactorValue[];
    this.gridData=this.ConvertData(this.data.values);
  }
  asFormGroup(o: BoardingPlaceDensityOfPeopleFactor): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: BoardingPlaceDensityOfPeopleFactor;
  @Input('isEditable') isEditable: boolean;
  @Input('transportModes') transportModes: TransportMode[];
  form: FormGroup;
  lascCtrl;
  matrix: BoardingPlaceDensityOfPeopleFactorData[] = [];
  gridData: GridData=new GridData();

  ConvertData(values:BoardingPlaceDensityOfPeopleFactorValue[]): GridData {
    for (let i = 0; i < values.length; i++) {
      const element = values[i];
      let boardingPlaceDensityOfPeopleFactorData:BoardingPlaceDensityOfPeopleFactorData = new BoardingPlaceDensityOfPeopleFactorData;
      boardingPlaceDensityOfPeopleFactorData.value=element.value;
      boardingPlaceDensityOfPeopleFactorData.transportModeId=element.transportModeId;
      boardingPlaceDensityOfPeopleFactorData.colId=1;
      this.matrix.push(boardingPlaceDensityOfPeopleFactorData);
    }


    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.transportModes.length; i++) {
      const headerEntry =  this.transportModes[i];
      rowHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    colHeaders.push(new IdValue(1,'fepd'));

    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.matrix.sort((a, b) => a.colId - b.colId);
    grid.colProp = 'colId';
    grid.rowProp = 'transportModeId';
    grid.switchColWithRow = false;
    return grid;
  }
  normalize(temp: BoardingPlaceDensityOfPeopleFactorData[]) {
    let tmp:BoardingPlaceDensityOfPeopleFactorValue[]=[];
    for (let index = 0; index < temp.length; index++) {
      const element = temp[index];
      let tmpValue:BoardingPlaceDensityOfPeopleFactorValue=new BoardingPlaceDensityOfPeopleFactorValue;
      tmpValue.transportModeId=element.transportModeId;
      tmpValue.value=element.value;
      tmp.push(tmpValue);
    }
    this.data.values=tmp;
  }
  save()
  {
    
    let clonedGridData = this.cloneService.deepClone(this.gridData.matrix) as BoardingPlaceDensityOfPeopleFactorData[];
    this.normalize(clonedGridData);
    
    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
